/* CS Konfigurator: Modell -> Halterung -> Farbe -> Produkt
   Katalog kommt serverseitig aus Liquid (application/json), kein Hardcoding.
   Warenkorb ueber Dawn cart-notification / cart-drawer (Muster aus product-form.js). */

(() => {
  if (customElements.get('cs-configurator')) return;

  const LINE_ORDER = ['slide', 'verschluss', 'bilderrahmen'];
  /* Farbwerte kommen aus den Produktoptionen und sind wie die Modellwerte
     uebersetzt: DE "Schwarz"/"Weiß", EN "Black"/"White". Ohne die
     englischen Keys fielen auf /en beide Swatches auf das graue Fallback. */
  const SWATCHES = {
    schwarz: '#16181C', black: '#16181C',
    weiss: '#FFFFFF', 'weiß': '#FFFFFF', white: '#FFFFFF',
  };
  const PAY_LABELS = {
    paypal: 'PayPal',
    klarna: 'Klarna',
    'klarna-pay-later': 'Klarna',
    visa: 'Visa',
    master: 'Mastercard',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    shopify_pay: 'Shop Pay',
    amazon_payments: 'Amazon Pay',
    sofort: 'Sofort',
    eps: 'EPS',
    american_express: 'Amex',
    maestro: 'Maestro',
    bancontact: 'Bancontact',
  };

  /* Die Modellwerte kommen aus den Produktoptionen und sind uebersetzt:
     DE "Für iPad Air 1 (9.7 Zoll - 2013)", EN "For iPad Air 1 (9.7 inch - 2013)".
     norm() muss daraus in JEDER Sprache denselben Key erzeugen, sonst greifen
     die Deeplinks vom Modellfinder (?modell=ipadair197zoll2013) auf /en ins
     Leere. Deutsch bleibt die kanonische Form, damit bestehende und
     gebookmarkte Links gueltig bleiben. */
  const PREFIX_RE = /^(f[üu]r|for)\s+/i;

  /* Zusaetzlich zur Einheit weichen die Ordinalzahlen ab:
     DE "1. Gen" <-> EN "1st Gen", "4. Gen" <-> "4th Gen". Ohne das
     Zusammenfuehren laufen 27 Modell-Deeplinks auf /en ins Leere. */
  const norm = (s) =>
    (s || '')
      .toLowerCase()
      .replace(PREFIX_RE, '')
      .replace(/\binch\b/g, 'zoll')
      .replace(/\b(\d+)(st|nd|rd|th)\b/g, '$1')
      .replace(/[^a-z0-9äöüß]/g, '');

  const stripFuer = (s) => (s || '').replace(PREFIX_RE, '');

  /* Farb-Parameter in der URL sprachneutral (CRO-0a, Audit N15): der rohe
     Optionswert ("Weiß"/"White") brach beim Sprachwechsel - /en mit
     farbe=Weiß verlor die Farbe und damit die Kaufkarte. Kanonisch sind
     "schwarz"/"weiss"; alte Links mit Schwarz/Weiß/Black/White bleiben gueltig. */
  const COLOR_KEYS = { black: 'schwarz', white: 'weiss', 'weiß': 'weiss' };
  const colorKey = (c) => {
    const k = norm(c).replace(/ß/g, 'ss');
    return COLOR_KEYS[k] || k;
  };

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Radio-Indikator (rein dekorativ, Zustand traegt aria-pressed des
     Buttons): signalisiert schon im Ruhezustand "das ist eine waehlbare
     Option" - auf Touch gibt es keinen Hover, der das sonst uebernimmt. */
  const radioHTML = `<span class="cs-config__radio" aria-hidden="true">
      <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.3 4.9 8.7 9.5 3.4"></path></svg>
    </span>`;

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Platzhalter-Interpolation fuer die Locale-Strings aus cs-configurator.liquid
     (Namespace cs_configurator). Shopifys `| t` laesst nicht uebergebene
     {{ var }} stehen, hier werden sie clientseitig mit den Laufzeitwerten
     gefuellt. Fehlt ein Key, bleibt der Text leer statt "undefined". */
  const fill = (tpl, vars) =>
    String(tpl == null ? '' : tpl).replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) =>
      vars && vars[k] != null ? String(vars[k]) : m
    );

  class CsConfigurator extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-cs-catalog]');
      if (!dataEl) return;
      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      this.catalog = (data.series || []).filter((s) => LINE_ORDER.some((lk) => s.lines[lk]));
      this.meta = data.lines || {};
      this.arEnabled = !!data.arEnabled;
      this.payTypes = data.payTypes || [];
      this.strings = data.strings || {};
      /* t('key', {var: wert}) -> lokalisierter String. Bewusst ohne Fallback
         auf deutsche Literale: ein fehlender Key soll im Preview auffallen,
         nicht stillschweigend Deutsch in die EN-Fassung zurueckholen. */
      this.t = (key, vars) => fill(this.strings[key], vars);
      this.state = { brand: null, seriesId: null, modelKey: null, line: null, color: null };

      this.els = {
        progress: this.querySelector('[data-cs-progress]'),
        brands: this.querySelector('[data-cs-brands]'),
        series: this.querySelector('[data-cs-series]'),
        models: this.querySelector('[data-cs-models]'),
        step2: this.querySelector('[data-cs-step2]'),
        step3: this.querySelector('[data-cs-step3]'),
        step4: this.querySelector('[data-cs-step4]'),
        modal: this.querySelector('[data-cs-modal]'),
        request: this.querySelector('[data-cs-request]'),
      };

      this.brands = [...new Set(this.catalog.map((s) => s.brand))];
      this.state.brand = this.brands[0] || null;
      this.autoSelectSeries();
      // Ausgangszustand merken: der Reset-Chip zeigt sich nur, wenn der
      // Kunde davon abgewichen ist (verklickt -> ein Klick zurueck).
      this.initialState = { brand: this.state.brand, seriesId: this.state.seriesId };
      this.restoreFromUrl();
      this.renderAll();
      this.initRequestForm();
      // Deep-Link-Landung (Modellfinder, Serien-Tabellen, Bookmarks): der
      // Browser springt nur auf #cs-finder (= Markenreihe), der wieder-
      // hergestellte Schritt lag 1-4 Viewports tiefer (Audit F003/N16).
      if (this.state.modelKey) this.scrollToRestoredStep();

      // Alle Reset-Buttons (Markenreihe + Schritt-Karten 2-4) und die
      // Modellanfrage-Trigger zentral abfangen - die Karten werden bei
      // jedem Render neu aufgebaut.
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cs-reset]')) this.resetAll();
        const jump = e.target.closest('[data-cs-jump]');
        if (jump) this.jumpTo(jump.dataset.csJump);
        const requestBtn = e.target.closest('[data-cs-request-open]');
        if (requestBtn) this.openRequest(requestBtn);
        if (e.target.closest('[data-cs-request-close]')) this.closeRequest();
        if (e.target.matches('[data-cs-request-overlay]')) this.closeRequest();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeInfo();
          this.closeRequest();
        }
      });
    }

    resetAll() {
      this.state = { brand: this.brands[0] || null, seriesId: null, modelKey: null, line: null, color: null };
      this.autoSelectSeries();
      this.update();
      this.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    /* Ziel-Element eines Schritts: die Kaufkarte mobil ueber ihre
       Info-Spalte (Titel, Preis, Kauf-Button), nicht ueber die Kartenoberkante -
       sonst liegt der Kauf-Button nach dem Sprung erneut unter der Falz. */
    stepTarget(key) {
      const el = this.els[key];
      if (!el) return null;
      if (key === 'step4' && isMobile()) return el.querySelector('.cs-config__product-info') || el;
      return el;
    }

    scrollToEl(el, behavior) {
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - 130;
      window.scrollTo({ top, behavior: behavior || (prefersReducedMotion() ? 'auto' : 'smooth') });
    }

    /* Textlinks "Modell/Halterung/Farbe aendern" in der Kaufkarte: nur
       scrollen, der Zustand bleibt (ersetzt den Reset-Chip, der alles verwarf). */
    jumpTo(key) {
      this.scrollToEl(this.stepTarget(key));
    }

    deepestStepTarget() {
      const order = ['step4', 'step3', 'step2', 'models'];
      const key = order.find((k) => this.els[k] && !this.els[k].hidden);
      return key ? this.stepTarget(key) : null;
    }

    /* Nur bei frischer Navigation (Link, Bookmark, neuer Tab); bei
       reload/back_forward stellt der Browser die Scrollposition selbst
       wieder her. Nach window.load, damit Bilder/Fonts das Layout nicht
       nachtraeglich verschieben; ohne Animation (kein Ritt ueber die Seite). */
    scrollToRestoredStep() {
      const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (nav && nav.type !== 'navigate') return;
      const run = () => requestAnimationFrame(() => this.scrollToEl(this.deepestStepTarget(), 'auto'));
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    }

    /* ---------- Katalog-Helfer ---------- */

    seriesForBrand(brand) {
      return this.catalog.filter((s) => s.brand === brand);
    }

    currentSeries() {
      return this.catalog.find((s) => s.id === this.state.seriesId) || null;
    }

    modelsFor(series) {
      if (series._models) return series._models;
      // Optionaler Serien-Filter: teilt ein Produkt mit gemischten Modellen
      // in mehrere Serien-Kacheln (z. B. Samsung A- vs. S-Serie).
      const filter = (series.modelFilter || '').toLowerCase();
      const map = new Map();
      LINE_ORDER.forEach((lk) => {
        const line = series.lines[lk];
        if (!line) return;
        line.variants.forEach((v) => {
          if (filter && !(v.model || '').toLowerCase().includes(filter)) return;
          const key = norm(v.model);
          if (!key || map.has(key)) return;
          map.set(key, { key, label: stripFuer(v.model) });
        });
      });
      // Aufsteigend wie auf den Produktseiten (numerisch: iPad 5 vor iPad 10).
      series._models = [...map.values()].sort((a, b) =>
        a.label.localeCompare(b.label, 'de', { numeric: true, sensitivity: 'base' })
      );
      return series._models;
    }

    modelByKey(series, key) {
      return this.modelsFor(series).find((m) => m.key === key) || null;
    }

    lineHasModel(series, lk, key) {
      const line = series.lines[lk];
      return !!line && line.variants.some((v) => norm(v.model) === key);
    }

    /* Bestand zaehlt: ein Modell kann in einer Linie gefuehrt, aber (noch)
       ausverkauft sein - z. B. Platzhalter-Modelle vor der Konfiguration.
       Die Kennzeichnung soll frueh sichtbar sein, nicht erst am Kauf-Button. */
    lineModelInStock(series, lk, key) {
      const line = series.lines[lk];
      return !!line && line.variants.some((v) => norm(v.model) === key && v.available);
    }

    modelInStock(series, key) {
      return LINE_ORDER.some((lk) => this.lineModelInStock(series, lk, key));
    }

    variantFor(series, lk, key, color) {
      const line = series.lines[lk];
      if (!line) return null;
      return line.variants.find((v) => norm(v.model) === key && v.color === color) || null;
    }

    colorsFor(series, lk, key) {
      const line = series.lines[lk];
      if (!line) return [];
      const seen = [];
      line.variants.forEach((v) => {
        if (norm(v.model) === key && !seen.includes(v.color)) seen.push(v.color);
      });
      return seen;
    }

    modelPriceLabel(series, lk, key) {
      const line = series.lines[lk];
      if (!line) return '';
      if (key) {
        const v = line.variants.find((x) => norm(x.model) === key);
        if (v) return v.priceF;
      }
      return line.priceMin ? this.t('priceFrom', { price: line.priceMin }) : '';
    }

    lineName(lk) {
      return (this.meta[lk] && this.meta[lk].name) || lk;
    }

    /* ---------- State-Uebergaenge (Reset-Kaskaden wie im Prototyp) ---------- */

    autoSelectSeries() {
      const list = this.seriesForBrand(this.state.brand);
      this.state.seriesId = list.length === 1 ? list[0].id : null;
    }

    selectBrand(brand) {
      if (this.state.brand === brand) return;
      this.state = { brand, seriesId: null, modelKey: null, line: null, color: null };
      this.autoSelectSeries();
      this.update();
    }

    selectSeries(id) {
      if (this.state.seriesId === id) return;
      this.state.seriesId = id;
      this.state.modelKey = null;
      this.state.line = null;
      this.state.color = null;
      // Mit Scroll: die Modell-Liste erscheint unterhalb und laege auf
      // dem Handy sonst unbemerkt unter dem Falz.
      this.update(true);
    }

    selectModel(key) {
      const series = this.currentSeries();
      if (!series) return;
      const keepLine = this.state.line && this.lineModelInStock(series, this.state.line, key) ? this.state.line : null;
      const keepVariant = keepLine && this.state.color ? this.variantFor(series, keepLine, key, this.state.color) : null;
      const keepColor = keepVariant && keepVariant.available ? this.state.color : null;
      this.state.modelKey = key;
      this.state.line = keepLine;
      this.state.color = keepColor;
      this.update(true);
    }

    selectLine(lk) {
      const series = this.currentSeries();
      if (!series || !this.state.modelKey || !this.lineModelInStock(series, lk, this.state.modelKey)) return;
      const keepVariant =
        this.state.color ? this.variantFor(series, lk, this.state.modelKey, this.state.color) : null;
      this.state.line = lk;
      this.state.color = keepVariant && keepVariant.available ? this.state.color : null;
      this.update(true);
    }

    selectColor(color) {
      const series = this.currentSeries();
      const variant = series && this.state.line && this.state.modelKey
        ? this.variantFor(series, this.state.line, this.state.modelKey, color)
        : null;
      if (variant && !variant.available) return;
      this.state.color = color;
      this.update(true);
    }

    update(scroll) {
      const wasHidden = {
        models: this.els.models.hidden,
        step2: this.els.step2.hidden,
        step3: this.els.step3.hidden,
        step4: this.els.step4.hidden,
      };
      this.renderAll();
      this.syncUrl();
      if (!scroll) return;
      const target =
        ['step2', 'step3', 'step4'].find((k) => wasHidden[k] && !this.els[k].hidden) ||
        (wasHidden.models && !this.els.models.hidden ? 'models' : null);
      if (target) {
        requestAnimationFrame(() => this.scrollToEl(this.stepTarget(target)));
      }
    }

    /* ---------- URL-Sync ---------- */

    syncUrl() {
      const p = new URLSearchParams(window.location.search);
      ['modell', 'halterung', 'farbe'].forEach((k) => p.delete(k));
      if (this.state.modelKey) p.set('modell', this.state.modelKey);
      if (this.state.line) p.set('halterung', this.state.line);
      if (this.state.color) p.set('farbe', colorKey(this.state.color));
      const qs = p.toString();
      history.replaceState(null, '', `${location.pathname}${qs ? '?' + qs : ''}${location.hash}`);
    }

    restoreFromUrl() {
      const p = new URLSearchParams(window.location.search);
      const mk = p.get('modell');
      if (!mk) return;
      for (const series of this.catalog) {
        if (!this.modelsFor(series).some((m) => m.key === mk)) continue;
        this.state.brand = series.brand;
        this.state.seriesId = series.id;
        this.state.modelKey = mk;
        const line = p.get('halterung');
        // Deep-Links auf ausverkaufte Linien/Farben fallen auf den letzten
        // verfuegbaren Schritt zurueck - dort sind die Ausverkauft-Badges
        // sichtbar, statt erst am Kauf-Button in Schritt 4.
        if (line && this.lineModelInStock(series, line, mk)) {
          this.state.line = line;
          const colorParam = p.get('farbe');
          const color = colorParam
            ? this.colorsFor(series, line, mk).find((c) => colorKey(c) === colorKey(colorParam)) || null
            : null;
          const variant = color ? this.variantFor(series, line, mk, color) : null;
          if (variant && variant.available) this.state.color = color;
        }
        return;
      }
    }

    /* ---------- Rendering ---------- */

    renderAll() {
      this.renderProgress();
      this.renderBrands();
      this.renderSeries();
      this.renderModels();
      this.renderStep2();
      this.renderStep3();
      this.renderStep4();
    }

    renderProgress() {
      const labels = [
        this.t('progressModel'),
        this.t('progressMount'),
        this.t('progressColor'),
        this.t('progressDone'),
      ];
      const st = this.state;
      const done = [!!st.modelKey, !!st.line, !!st.color, !!(st.modelKey && st.line && st.color)];
      const activeIdx = !st.modelKey ? 0 : !st.line ? 1 : !st.color ? 2 : 3;
      this.els.progress.innerHTML = labels
        .map((label, i) => {
          const isDone = done[i] && i < 3;
          const cls = isDone ? 'is-done' : i === activeIdx ? 'is-active' : '';
          const line = i > 0 ? `<span class="cs-config__progress-line ${done[i - 1] ? 'is-done' : ''}"></span>` : '';
          return `${line}<span class="cs-config__progress-item ${cls}">
            <span class="cs-config__progress-circle">${isDone ? '✓' : i + 1}</span>
            <span class="cs-config__progress-label">${label}</span>
          </span>`;
        })
        .join('');
    }

    renderBrands() {
      // "Für"-Prefix ist Pflicht (Zubehör-Kennzeichnung, Markenrecht).
      const st = this.state;
      const dirty =
        !!st.modelKey || st.brand !== this.initialState.brand || st.seriesId !== this.initialState.seriesId;
      // Reset-Chip sitzt als letztes Element in der Markenreihe (neben
      // der letzten Marke) und erscheint erst nach einer Auswahl.
      const resetChip = dirty
        ? `<button type="button" class="cs-config__reset" data-cs-reset aria-label="${esc(this.t('reset'))}" title="${esc(this.t('reset'))}">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 12a9 9 0 1 0 2.6-6.4"></path>
              <path d="M3 4v5h5"></path>
            </svg>
          </button>`
        : '';
      this.els.brands.innerHTML =
        this.brands
          .map(
            (b) =>
              `<button type="button" class="cs-config__brand ${b === this.state.brand ? 'is-active' : ''}" data-brand="${esc(b)}" aria-pressed="${b === this.state.brand}">${esc(this.t('forLabel', { label: b }))}</button>`
          )
          .join('') + resetChip;
      this.els.brands.querySelectorAll('[data-brand]').forEach((btn) => {
        btn.addEventListener('click', () => this.selectBrand(btn.dataset.brand));
      });
      // Klick-Handling der Reset-Buttons laeuft delegiert (siehe init).
    }

    /* ---------- Bilder-Galerie (Schritt 2 + 4) ----------
       Kunden-Feedback: im Konfigurator sollen alle Produktbilder
       durchblaetterbar sein (Punkte, Pfeile, Swipe). Quelle ist das
       media-Array des Linien-Produkts aus dem Katalog: Eintraege
       {s: url, c: 'schwarz'|'weiss'|''} (Farb-Token aus dem Alt-Suffix,
       siehe cs-configurator.liquid). Mit color werden nur Bilder der
       gewaehlten Farbe plus farbneutrale uebernommen - vorher folgten auf
       das weisse Hauptbild die schwarzen Produktbilder (Paul 06.09.2026).
       Reine String-Eintraege (alter Katalog) bleiben lesbar. */

    lineMedia(line, firstImg, color) {
      const want = color ? colorKey(color) : null;
      const pool = (line.media || [])
        .filter((m) => typeof m === 'string' || !want || !m.c || m.c === want)
        .map((m) => (typeof m === 'string' ? m : m.s));
      const seen = new Set();
      const out = [];
      [firstImg].concat(pool).forEach((src) => {
        if (src && !seen.has(src)) {
          seen.add(src);
          out.push(src);
        }
      });
      return out;
    }

    /* opts: start = Index des Startbilds (Perspektiv-Modus: Frontal in
       der Mitte), invert = Swipe-Semantik "nach links wischen zeigt die
       Ansicht von links" (Pauls Turntable-Logik, nur Schritt 2),
       alts = eigene Alt-Texte je Slide (z. B. Perspektiv-Namen). */
    /* Galerie ohne Punkte (Pauls Wunsch 06.09.2026): mobil lagen die Dots
       ueber den Pfeilen; Navigation nur per Pfeil und Wischen. */
    galleryHTML(media, alt, opts) {
      const o = opts || {};
      const start = o.start || 0;
      const slides = media
        .map(
          (src, i) =>
            `<img src="${esc(src)}" alt="${esc(o.alts && o.alts[i] ? alt + ', ' + o.alts[i] : alt + (i ? ', ' + this.t('imageN', { n: i + 1 }) : ''))}" loading="lazy" class="cs-config__gal-slide ${i === start ? 'is-current' : ''}" data-gal-slide="${i}">`
        )
        .join('');
      const chevron = (dir) =>
        `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M${dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6'}"></path></svg>`;
      return `<div class="cs-config__gallery" data-gal data-gal-index="${start}" data-gal-count="${media.length}"${o.invert ? ' data-gal-invert="1"' : ''}>
          ${slides}
          <button type="button" class="cs-config__gal-arrow cs-config__gal-arrow--prev" data-gal-prev aria-label="${esc(this.t(o.invert ? 'viewLeft' : 'prevImage'))}">${chevron('prev')}</button>
          <button type="button" class="cs-config__gal-arrow cs-config__gal-arrow--next" data-gal-next aria-label="${esc(this.t(o.invert ? 'viewRight' : 'nextImage'))}">${chevron('next')}</button>
        </div>`;
    }

    setGalIndex(gal, idx) {
      const count = parseInt(gal.dataset.galCount, 10) || 1;
      const next = ((idx % count) + count) % count;
      gal.dataset.galIndex = String(next);
      gal.querySelectorAll('[data-gal-slide]').forEach((img) => {
        img.classList.toggle('is-current', parseInt(img.dataset.galSlide, 10) === next);
      });
    }

    /* Direkt-Bindings je Render (stopPropagation, damit die Karten-
       Auswahl in Schritt 2 nicht mitfeuert); Swipe via Touch-Delta. */
    bindGalleries(rootEl) {
      rootEl.querySelectorAll('[data-gal-prev], [data-gal-next]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const gal = btn.closest('[data-gal]');
          const delta = btn.hasAttribute('data-gal-prev') ? -1 : 1;
          this.setGalIndex(gal, parseInt(gal.dataset.galIndex, 10) + delta);
        });
      });
      rootEl.querySelectorAll('[data-gal]').forEach((gal) => {
        let x0 = null;
        gal.addEventListener('touchstart', (e) => {
          x0 = e.touches[0].clientX;
        }, { passive: true });
        gal.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          x0 = null;
          if (Math.abs(dx) < 40) return;
          /* Standard: Swipe nach links = naechstes Bild. Perspektiv-Modus
             (Schritt 2): Swipe nach links = Ansicht von LINKS (Index-1). */
          const invert = gal.dataset.galInvert === '1';
          const step = dx < 0 ? (invert ? -1 : 1) : (invert ? 1 : -1);
          this.setGalIndex(gal, parseInt(gal.dataset.galIndex, 10) + step);
        }, { passive: true });
      });
    }

    /* Reset-Chip oben rechts in den Schritt-Karten 2-4: bringt den
       Kunden mit einem Klick zurueck zur Markenwahl (Schritt 1). */
    stepResetChip() {
      const label = this.t('backToBrand');
      return `<button type="button" class="cs-config__step-reset" data-cs-reset aria-label="${label}" title="${label}">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3 12a9 9 0 1 0 2.6-6.4"></path>
            <path d="M3 4v5h5"></path>
          </svg>
        </button>`;
    }

    renderSeries() {
      const list = this.seriesForBrand(this.state.brand);
      if (list.length <= 1) {
        this.els.series.hidden = true;
        this.els.series.innerHTML = '';
        return;
      }
      const firstShow = this.els.series.hidden;
      this.els.series.hidden = false;
      this.els.series.innerHTML = `<div class="${firstShow ? 'cs-fade-up' : ''}">
        <div class="cs-config__models-label">${esc(this.t('chooseSeries'))}</div>
        <div class="cs-config__series-grid">
          ${list
            .map(
              (s) => `<button type="button" class="cs-config__series-tile ${s.id === this.state.seriesId ? 'is-active' : ''}" data-series="${esc(s.id)}" aria-pressed="${s.id === this.state.seriesId}">
                ${radioHTML}
                <span class="cs-config__series-name">${esc(this.t('forLabel', { label: s.label }))}</span>
              </button>`
            )
            .join('')}
        </div>
      </div>`;
      this.els.series.querySelectorAll('[data-series]').forEach((btn) => {
        btn.addEventListener('click', () => this.selectSeries(btn.dataset.series));
      });
    }

    renderModels() {
      const series = this.currentSeries();
      if (!series) {
        this.els.models.hidden = true;
        this.els.models.innerHTML = '';
        return;
      }
      const firstShow = this.els.models.hidden;
      this.els.models.hidden = false;
      const models = this.modelsFor(series);
      // Verfuegbare Modelle zuerst, Platzhalter (bewusst gefuehrt, aktuell
      // ausverkauft) gesammelt darunter - bleiben sichtbar und waehlbar
      // (Schritt 2 zeigt dann "Ausverkauft · Interesse melden"). Vorher
      // standen sie als Badge-Kacheln quer durch die Liste (Audit F008).
      const inStock = models.filter((m) => this.modelInStock(series, m.key));
      const soldOut = models.filter((m) => !this.modelInStock(series, m.key));
      const tile = (m, sold) =>
        `<button type="button" class="cs-config__model ${m.key === this.state.modelKey ? 'is-active' : ''} ${sold ? 'is-soldout' : ''}" data-model="${esc(m.key)}" aria-pressed="${m.key === this.state.modelKey}">${radioHTML}<span class="cs-config__model-label">${esc(this.t('forLabel', { label: m.label }))}${sold ? ` <span class="cs-config__model-soldout">- ${esc(this.t('soldOut'))}</span>` : ''}</span></button>`;
      this.els.models.innerHTML = `<div class="${firstShow ? 'cs-fade-up' : ''}">
        <div class="cs-config__models-label">${esc(this.t('chooseModel'))} <span>${esc(this.t('chooseModelHint'))}</span></div>
        <div class="cs-config__models-grid">
          ${inStock.map((m) => tile(m, false)).join('')}
        </div>
        ${
          soldOut.length
            ? `<div class="cs-config__models-label cs-config__models-label--soldout">${esc(this.t('notAvailableGroup'))}</div>
        <div class="cs-config__models-grid cs-config__models-grid--soldout">
          ${soldOut.map((m) => tile(m, true)).join('')}
        </div>`
            : ''
        }
        <div class="cs-config__request-hint">
          <span>${esc(this.t(models.length ? 'requestMissing' : 'requestNoModels'))}</span>
          <button type="button" class="cs-config__request-link" data-cs-request-open="konfigurator-modelle">${esc(this.t('requestMissingCta'))}</button>
        </div>
      </div>`;
      this.els.models.querySelectorAll('[data-model]').forEach((btn) => {
        btn.addEventListener('click', () => this.selectModel(btn.dataset.model));
      });
    }

    renderStep2() {
      const series = this.currentSeries();
      const model = series && this.state.modelKey ? this.modelByKey(series, this.state.modelKey) : null;
      if (!model) {
        this.els.step2.hidden = true;
        this.els.step2.innerHTML = '';
        return;
      }
      const firstShow = this.els.step2.hidden;
      this.els.step2.hidden = false;
      const modelShort = model.label.split(' (')[0];
      /* Galerie-Stand je Linie ueber den Re-Render retten: Kartenwahl
         loest renderStep2 neu aus und wuerde die gewaehlte Ansicht sonst
         auf die Frontalansicht zuruecksetzen. */
      const galIdx = {};
      this.els.step2.querySelectorAll('[data-line]').forEach((c) => {
        const g = c.querySelector('[data-gal]');
        const i = g ? parseInt(g.dataset.galIndex, 10) : NaN;
        if (Number.isInteger(i)) galIdx[c.dataset.line] = i;
      });
      const cards = LINE_ORDER.filter((lk) => series.lines[lk])
        .map((lk) => {
          const line = series.lines[lk];
          const meta = this.meta[lk] || {};
          const exists = this.lineHasModel(series, lk, model.key);
          const available = exists && this.lineModelInStock(series, lk, model.key);
          const active = this.state.line === lk;
          const price = available
            ? this.modelPriceLabel(series, lk, model.key)
            : exists ? this.t('soldOut') : '';
          // Schritt 2 = Perspektiv-Modell (Pauls Turntable-Logik, keine
          // Produktfotos): Standard ist die FRONTALANSICHT, Swipe nach
          // links zeigt die Ansicht von links, Swipe nach rechts die von
          // rechts. Reihenfolge im Array: [links, frontal, rechts],
          // Start in der Mitte.
          const baseImg = meta.img || line.image;
          const hoverImg = meta.imgHover;
          const views = [
            { src: meta.viewLeft, name: this.t('viewLeft') },
            { src: baseImg, name: this.t('viewFront') },
            { src: meta.viewRight, name: this.t('viewRight') },
          ].filter((v) => v.src);
          let img;
          if (views.length > 1) {
            img = this.galleryHTML(
              views.map((v) => v.src),
              this.t('mountOf', { line: this.lineName(lk) }),
              {
                start: galIdx[lk] ?? views.findIndex((v) => v.src === baseImg),
                invert: true,
                alts: views.map((v) => v.name),
              }
            );
          } else if (baseImg) {
            img = `<img src="${esc(baseImg)}" alt="${esc(this.t('mountOf', { line: this.lineName(lk) }))}" loading="lazy">${
              hoverImg ? `<img class="cs-config__img-hover" src="${esc(hoverImg)}" alt="" loading="lazy" aria-hidden="true">` : ''
            }`;
          } else {
            img = `<span class="cs-config__variant-img-note">${esc(this.t('renderingSoon'))}</span>`;
          }
          const foot = available
            ? `<button type="button" class="cs-config__variant-more" data-info="${lk}">${esc(this.t('learnMore'))}</button>`
            : `<div class="cs-config__variant-unavailable">${esc(this.t(exists ? 'soldOutModel' : 'notAvailableModel'))}<br>
                <button type="button" class="cs-config__request-link" data-cs-request-open="konfigurator-halterung" data-request-line-name="${esc(this.lineName(lk))}">${esc(this.t('requestLineCta'))}</button>
              </div>`;
          return `<div class="cs-config__variant ${active ? 'is-active' : ''} ${available ? '' : 'is-disabled'}" data-line="${lk}"${available ? ` role="button" tabindex="0" aria-pressed="${active}"` : ''}>
            <div class="cs-config__variant-img">${img}</div>
            <div class="cs-config__variant-row">
              ${available ? radioHTML : ''}
              <span class="cs-config__variant-name">${esc(this.lineName(lk))}</span>
              <span class="cs-config__variant-price">${esc(price)}</span>
            </div>
            <div class="cs-config__variant-desc">${esc(meta.desc || '')}</div>
            ${meta.goodif ? `<div class="cs-config__variant-goodif">${esc(meta.goodif)}</div>` : ''}
            ${foot}
          </div>`;
        })
        .join('');
      /* CRO 1.7: Linien-Uebersicht als Chip-Reihe (nur mobil sichtbar) -
         alle verfuegbaren Linien mit Preis auf einen Blick, Tap scrollt die
         Karte in den Viewport. Dynamisch aus den Linien der Serie. */
      const chips = LINE_ORDER.filter((lk) => series.lines[lk])
        .map((lk) => {
          const exists = this.lineHasModel(series, lk, model.key);
          const available = exists && this.lineModelInStock(series, lk, model.key);
          const label = available
            ? this.modelPriceLabel(series, lk, model.key)
            : this.t(exists ? 'soldOut' : 'notAvailableGroup');
          return `<button type="button" class="cs-config__line-chip ${this.state.line === lk ? 'is-active' : ''} ${available ? '' : 'is-muted'}" data-line-jump="${lk}">
            <span>${esc(this.lineName(lk))}</span><span class="cs-config__line-chip-meta">${esc(label)}</span>
          </button>`;
        })
        .join('');
      this.els.step2.innerHTML = `<div class="cs-config__card ${firstShow ? 'cs-fade-up' : ''}">
        <div class="cs-config__step-head">
          <h2 class="cs-config__step-title"><span class="cs-config__step-num">2</span> · ${esc(this.t('step2Title', { model: modelShort }))}</h2>
        </div>
        <div class="cs-config__step-intro">${esc(this.strings.step2Intro || '')}</div>
        <div class="cs-config__guide">${esc(this.t('step2Guide'))}</div>
        <div class="cs-config__line-chips" role="list">${chips}</div>
        <div class="cs-config__variants">${cards}</div>
        <div class="cs-config__price-note">${esc(this.t('priceNote'))}</div>
      </div>`;
      // Nur waehlbare Karten bekommen Rollen-Semantik und selectLine-Handler:
      // in der nicht-verfuegbaren Karte sitzt der "Interesse melden"-Button,
      // dessen Enter/Space sonst vom Karten-keydown verschluckt wuerde
      // (role="button" wuerde ihn zudem fuer Screenreader plattdruecken).
      this.els.step2.querySelectorAll('[data-line]:not(.is-disabled)').forEach((card) => {
        const lk = card.dataset.line;
        card.addEventListener('click', () => this.selectLine(lk));
        card.addEventListener('keydown', (e) => {
          if (e.target.closest('button')) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.selectLine(lk);
          }
        });
      });
      this.els.step2.querySelectorAll('[data-info]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.openInfo(btn.dataset.info);
        });
      });
      this.els.step2.querySelectorAll('[data-line-jump]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = this.els.step2.querySelector(`[data-line="${btn.dataset.lineJump}"]`);
          if (card) this.scrollToEl(card);
        });
      });
      this.bindGalleries(this.els.step2);
    }

    renderStep3() {
      const series = this.currentSeries();
      if (!series || !this.state.modelKey || !this.state.line) {
        this.els.step3.hidden = true;
        this.els.step3.innerHTML = '';
        return;
      }
      const firstShow = this.els.step3.hidden;
      this.els.step3.hidden = false;
      const colors = this.colorsFor(series, this.state.line, this.state.modelKey);
      this.els.step3.innerHTML = `<div class="cs-config__card ${firstShow ? 'cs-fade-up' : ''}">
        <h2 class="cs-config__step-title"><span class="cs-config__step-num">3</span> · ${esc(this.t('step3Title'))}</h2>
        <div class="cs-config__guide">${esc(this.t('step3Guide'))}</div>
        <div class="cs-config__colors">
          ${colors
            .map((c) => {
              const swatch = SWATCHES[c.trim().toLowerCase()] || '#DDD';
              const variant = this.variantFor(series, this.state.line, this.state.modelKey, c);
              const sold = !variant || !variant.available;
              // 45-Grad-Schichtlinien wie die 3D-Druck-Struktur - stellt
              // die Material-Erwartung schon bei der Farbwahl richtig.
              const stripe = swatch === '#FFFFFF' ? 'rgba(11, 13, 18, 0.12)' : 'rgba(255, 255, 255, 0.16)';
              return `<button type="button" class="cs-config__color ${c === this.state.color ? 'is-active' : ''} ${sold ? 'is-soldout' : ''}" data-color="${esc(c)}" aria-pressed="${c === this.state.color}" ${sold ? 'aria-disabled="true"' : ''}>
                ${sold ? '' : radioHTML}
                <span class="cs-config__color-swatch" style="background: repeating-linear-gradient(45deg, ${stripe} 0 2px, transparent 2px 6px), ${swatch};"></span>
                <span class="cs-config__color-name">${esc(c)}</span>
                ${sold ? `<span class="cs-config__soldout-flag">${esc(this.t('soldOut'))}</span>` : ''}
              </button>`;
            })
            .join('')}
        </div>
      </div>`;
      this.els.step3.querySelectorAll('[data-color]').forEach((btn) => {
        btn.addEventListener('click', () => this.selectColor(btn.dataset.color));
      });
    }

    renderStep4() {
      const series = this.currentSeries();
      const st = this.state;
      const model = series && st.modelKey ? this.modelByKey(series, st.modelKey) : null;
      const variant = model && st.line && st.color ? this.variantFor(series, st.line, st.modelKey, st.color) : null;
      if (!variant) {
        this.els.step4.hidden = true;
        this.els.step4.innerHTML = '';
        return;
      }
      const firstShow = this.els.step4.hidden;
      this.els.step4.hidden = false;
      const line = series.lines[st.line];
      const meta = this.meta[st.line] || {};
      const img = meta.img4 || variant.image || line.image;
      const imgHover = meta.img4Hover;
      // Schritt 4 = echte Produktbilder wie auf der Produktseite,
      // Variantenbild zuerst; img4-Setting bleibt Einzelbild-Fallback.
      const media = this.lineMedia(line, variant.image || line.image, st.color);
      const arBadge = this.arEnabled
        ? `<div class="cs-config__ar-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2557D6" stroke-width="1.8" aria-hidden="true"><path d="M12 2l8 4.5v11L12 22l-8-4.5v-11L12 2z"></path><path d="M12 22v-9.5M4 6.5l8 6 8-6"></path></svg>
            ${esc(this.t('arBadge'))}
          </div>`
        : '';
      this.els.step4.innerHTML = `<div class="cs-config__card cs-config__card--final ${firstShow ? 'cs-fade-up' : ''}">
        <h2 class="cs-config__step-title"><span class="cs-config__step-num">4</span> · ${esc(this.t('step4Title'))}</h2>
        <div class="cs-config__guide">${esc(this.t('step4Guide'))}</div>
        <div class="cs-config__product">
          <div class="cs-config__product-media">
            <div class="cs-config__product-img">${
              media.length > 1
                ? this.galleryHTML(media, this.t('mountOfColor', { line: this.lineName(st.line), color: st.color }))
                : img
                  ? `<img src="${esc(img)}" alt="${esc(this.t('mountOfColor', { line: this.lineName(st.line), color: st.color }))}" loading="lazy">${
                      imgHover ? `<img class="cs-config__img-hover" src="${esc(imgHover)}" alt="" loading="lazy" aria-hidden="true">` : ''
                    }`
                  : ''
            }</div>
            ${arBadge}
          </div>
          <div class="cs-config__product-info">
            <h3 class="cs-config__product-title">${esc(this.t('mountOfColor', { line: this.lineName(st.line), color: st.color }))}</h3>
            <div class="cs-config__product-change">
              <button type="button" class="cs-config__change-link" data-cs-jump="models">${esc(this.t('changeModel'))}</button>
              <span aria-hidden="true">·</span>
              <button type="button" class="cs-config__change-link" data-cs-jump="step2">${esc(this.t('changeLine'))}</button>
              <span aria-hidden="true">·</span>
              <button type="button" class="cs-config__change-link" data-cs-jump="step3">${esc(this.t('changeColor'))}</button>
            </div>
            <div class="cs-config__product-sub">${esc(this.t('productSub', { model: model.label }))}</div>
            <div class="cs-config__product-price">${esc(variant.priceF)}</div>
            <div class="cs-config__product-fine cs-config__product-fine--short">${esc(this.t('finePrint'))}</div>
            <button type="button" class="cs-config__atc" data-atc ${variant.available ? '' : 'disabled'}>${esc(this.t(variant.available ? 'addToCart' : 'unavailable'))}</button>
            <div class="cs-config__error" data-cs-error hidden></div>
            ${this.strings.umbauNote ? `<div class="cs-config__product-umbau">${esc(this.t('umbauNote'))}</div>` : ''}
            <a class="cs-config__details-link" href="${esc(line.url)}?variant=${variant.id}">${esc(this.t('detailsLink'))}</a>
            ${
              variant.dims
                ? `<div class="cs-config__product-dims"><strong>${esc(this.t('dimsLabel'))}:</strong> ${esc(variant.dims)} <span>(${esc(this.t('dimsAxes'))})</span></div>`
                : ''
            }
            ${
              variant.hb
                ? `<div class="cs-config__product-hb"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2557D6" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2"></rect><line x1="6.5" y1="17" x2="17.5" y2="17"></line><circle cx="12" cy="19.25" r="1.1"></circle></svg><span><strong>${esc(this.t('hbLabel'))}:</strong> ${esc(this.t('hbText'))}</span></div>`
                : ''
            }
            <div class="cs-config__product-fine cs-config__product-fine--facts">${esc(this.t('finePrintFacts'))}</div>
            <div class="cs-config__product-trust"><span>${esc(this.t('trustShipping'))}</span><span>${esc(this.t('trustReturns'))}</span>${this.strings.trustReviews ? `<span>${esc(this.t('trustReviews'))}</span>` : ''}</div>
            ${this.renderPayChips()}
          </div>
        </div>
      </div>`;
      const atc = this.els.step4.querySelector('[data-atc]');
      if (variant.available) atc.addEventListener('click', () => this.addToCart(variant.id, atc));
      this.bindGalleries(this.els.step4);
    }

    renderPayChips() {
      const seen = [];
      this.payTypes.forEach((t) => {
        const label = PAY_LABELS[t];
        if (label && !seen.includes(label)) seen.push(label);
      });
      if (!seen.length) return '';
      return `<div class="cs-config__product-pay">
        <span class="cs-config__product-pay-note">${esc(this.t('payNote'))}</span>
        ${seen.map((l) => `<span class="cs-config__product-pay-chip">${esc(l)}</span>`).join('')}
      </div>`;
    }

    /* ---------- Info-Layer ---------- */

    openInfo(lk) {
      const meta = this.meta[lk] || {};
      const series = this.currentSeries();
      const line = series ? series.lines[lk] : null;
      if (!line) return;
      const price = this.modelPriceLabel(series, lk, this.state.modelKey);
      const infoImg = meta.img || line.image;
      const media = meta.video
        ? `<video src="${esc(meta.video)}" autoplay muted loop playsinline></video>`
        : infoImg
          ? `<img src="${esc(infoImg)}" alt="${esc(this.t('mountOf', { line: this.lineName(lk) }))}">`
          : '';
      const bullets = (meta.bullets || [])
        .filter(Boolean)
        .map((b) => `<li class="cs-config__modal-bullet"><span>${esc(b)}</span></li>`)
        .join('');
      this.els.modal.hidden = false;
      this.els.modal.innerHTML = `<div class="cs-config__modal-overlay" data-modal-overlay>
        <div class="cs-config__modal cs-scope" role="dialog" aria-modal="true" aria-label="${esc(this.t('mountOf', { line: this.lineName(lk) }))}">
          <div class="cs-config__modal-head">
            <h3 class="cs-config__modal-title">${esc(this.t('mountOf', { line: this.lineName(lk) }))}</h3>
            <button type="button" class="cs-config__modal-close" data-modal-close aria-label="${esc(this.t('close'))}">✕</button>
          </div>
          <div class="cs-config__modal-body">
            <div class="cs-config__modal-media">
              <div class="cs-config__modal-media-frame">
                ${media}
                ${meta.caption ? `<div class="cs-config__modal-caption">${esc(meta.caption)}</div>` : ''}
              </div>
            </div>
            <div class="cs-config__modal-info">
              ${meta.goodif ? `<div class="cs-config__modal-goodif">${esc(meta.goodif)}</div>` : ''}
              <ul class="cs-config__modal-bullets">${bullets}</ul>
              <div class="cs-config__modal-cta-wrap">
                <button type="button" class="cs-config__modal-cta" data-modal-choose="${lk}">${esc(this.t('chooseMount'))}${price ? ' · ' + esc(price) : ''}</button>
                <div class="cs-config__price-note">${esc(this.t('priceNote'))}</div>
              </div>
            </div>
          </div>
        </div>
      </div>`;
      document.body.style.overflow = 'hidden';
      this.els.modal.querySelector('[data-modal-overlay]').addEventListener('click', (e) => {
        if (e.target === e.currentTarget) this.closeInfo();
      });
      this.els.modal.querySelector('[data-modal-close]').addEventListener('click', () => this.closeInfo());
      this.els.modal.querySelector('[data-modal-choose]').addEventListener('click', (e) => {
        const key = e.currentTarget.dataset.modalChoose;
        this.closeInfo();
        this.selectLine(key);
      });
    }

    closeInfo() {
      if (this.els.modal.hidden) return;
      this.els.modal.hidden = true;
      this.els.modal.innerHTML = '';
      document.body.style.overflow = '';
    }

    /* ---------- Modellanfrage ----------
       Das Formular-Markup kommt serverseitig aus snippets/cs-request-form.liquid
       (inkl. Erfolgs-/Fehlerzustand nach dem POST-Redirect). JS togglet deshalb
       nur das hidden-Attribut und befuellt die Kontextfelder - nie innerHTML. */

    openRequest(btn) {
      const host = this.els.request;
      if (!host) return;
      const overlay = host.querySelector('[data-cs-request-overlay]');
      if (!overlay) {
        // Erfolgszustand: statt Formular steht das Bestaetigungs-Band -
        // Klick-Feedback statt stummem Nichtstun
        const band = host.querySelector('[data-cs-request-success]');
        if (band) {
          band.scrollIntoView({ block: 'center' });
          band.focus();
        }
        return;
      }
      if (host.querySelector('[data-cs-request-done]')) {
        // Meldung in dieser Sitzung schon per fetch abgeschickt (cs-request.js):
        // das Band steht im Modal, Prefill/Intro nicht mehr anfassen
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
        const doneBand = host.querySelector('[data-cs-request-success]');
        if (doneBand) doneBand.focus();
        return;
      }
      const series = this.currentSeries();
      const source = (btn && btn.dataset.csRequestOpen) || 'konfigurator';
      // Sackgasse "Modell da, Halterungslinie fehlt": nur hier ist das gewaehlte
      // Modell die gesuchte Antwort - im "Modell fehlt"-Fall bliebe ein Prefill
      // aus dem Browsing-Kontext irrefuehrend.
      const isLineCase = source === 'konfigurator-halterung';
      const model = series && this.state.modelKey ? this.modelByKey(series, this.state.modelKey) : null;
      const put = (sel, val) => {
        const el = host.querySelector(sel);
        if (el) el.value = val || '';
      };
      const modelInput = host.querySelector('[data-request-model]');
      if (modelInput) {
        if (isLineCase && model) {
          modelInput.value = model.label;
          modelInput.dataset.csPrefill = model.label;
        } else if (modelInput.dataset.csPrefill && modelInput.dataset.csPrefill === modelInput.value) {
          // unangetastetes Auto-Prefill eines frueheren Line-Falls raeumen -
          // vom Kunden Getipptes bleibt stehen
          modelInput.value = '';
          delete modelInput.dataset.csPrefill;
        }
      }
      put('[data-request-brand]', this.state.brand);
      put('[data-request-series]', series ? series.label : '');
      put('[data-request-line]', isLineCase && btn ? btn.dataset.requestLineName : '');
      put('[data-request-source]', source);
      this.setRequestIntro(isLineCase);
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      const focusTarget = modelInput && !modelInput.value ? modelInput : host.querySelector('.cs-request__submit');
      if (focusTarget) focusTarget.focus();
    }

    closeRequest() {
      const host = this.els.request;
      const overlay = host && host.querySelector('[data-cs-request-overlay]');
      if (!overlay || overlay.hidden) return;
      overlay.hidden = true;
      document.body.style.overflow = '';
    }

    setRequestIntro(isLineCase) {
      const host = this.els.request;
      const introDefault = host.querySelector('[data-cs-request-intro]');
      const introLine = host.querySelector('[data-cs-request-intro-line]');
      if (introDefault) introDefault.hidden = isLineCase;
      if (introLine) introLine.hidden = !isLineCase;
    }

    /* Nach dem Kontaktformular-POST laedt Shopify die Seite neu: Erfolg und
       Fehler kommen serverseitig gerendert zurueck (Band bzw. offenes Modal).
       Liquid gibt dabei nur email/body zurueck - Modell und Kontextfelder
       rettet deshalb sessionStorage ueber den Roundtrip. */
    initRequestForm() {
      const host = this.els.request;
      if (!host) return;
      const KEY = 'cs-request-ctx';
      const form = host.querySelector('#cs-request-form');
      if (form) {
        form.addEventListener('submit', () => {
          const ctx = {};
          ['model', 'brand', 'series', 'line', 'source'].forEach((k) => {
            const el = form.querySelector(`[data-request-${k}]`);
            if (el) ctx[k] = el.value;
          });
          try {
            sessionStorage.setItem(KEY, JSON.stringify(ctx));
          } catch (e) {
            /* Speicher blockiert: schlimmstenfalls fehlt nach einem
               Server-Fehler das Prefill */
          }
        });
      }
      const band = host.querySelector('[data-cs-request-success]');
      if (band) {
        try {
          sessionStorage.removeItem(KEY);
        } catch (e) {}
        requestAnimationFrame(() => {
          band.scrollIntoView({ block: 'center' });
          band.focus();
        });
        return;
      }
      if (host.querySelector('[data-cs-request-errors]')) {
        let ctx = null;
        try {
          ctx = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        } catch (e) {}
        if (ctx) {
          Object.keys(ctx).forEach((k) => {
            const el = host.querySelector(`[data-request-${k}]`);
            // source hat serverseitig einen nicht-leeren Default und muss
            // deshalb immer ueberschrieben werden, sonst degradiert das
            // Quelle-Token nach jedem Fehler-Roundtrip auf 'konfigurator'
            if (el && (k === 'source' || !el.value)) el.value = ctx[k];
          });
        }
        this.setRequestIntro(!!(ctx && ctx.source === 'konfigurator-halterung'));
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => {
          const err = host.querySelector('[data-cs-request-errors]');
          if (err) {
            err.scrollIntoView({ block: 'center' });
            err.focus();
          }
        });
      }
    }

    /* ---------- Warenkorb ---------- */

    showError(msg) {
      const el = this.els.step4.querySelector('[data-cs-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }

    addToCart(variantId, button) {
      button.setAttribute('disabled', '');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', 1);
      if (cart && cart.getSectionsToRender) {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      const config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = body;
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl, config)
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message || this.t('errorGeneric'));
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cs-configurator',
              productVariantId: variantId,
              cartData: response,
            });
          }
          cart.renderContents(response);
        })
        .catch(() => this.showError(this.t('errorRetry')))
        .finally(() => button.removeAttribute('disabled'));
    }
  }

  customElements.define('cs-configurator', CsConfigurator);
})();
